/**
 * @module Address-Finder Exports
 */
import { watch } from "./watch";
import { Controller, defaults } from "./controller";
/**
 * Configure and launch an instance of the Address Finder
 *
 * This method will create and return a new AddressFinder instance. It will also add a global reference to the controller at `AddressFinder.controllers`
 */
export const setup = (config) => {
    const c = new Controller(config);
    controllers.push(c);
    return c;
};
/**
 * Configure and launch an instance of the Address Finder
 *
 * This is equivalent to invoking `setup` except inside a DOMContentLoaded event callback
 */
export const go = (config, d) => new Promise((resolve, _) => {
    (d || document).addEventListener("DOMContentLoaded", (_) => {
        const c = setup(config);
        return resolve(c);
    });
}).catch((_) => null);
/**
 * Cache of Address Finder controllers
 */
export const controllers = [];
/**
 * Namespace that exports Address Finder methods and classes
 */
export const AddressFinder = {
    setup,
    controllers,
    Controller,
    defaults,
    watch,
    go,
};
/**
 * Configure Address Finder to watch for available address fields to bind
 */
export { watch };
/**
 * Default Address Finder Controller configuration
 */
export { defaults };
/**
 * Controller Export
 */
export { Controller };
